import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { useUXPContext } from '@core/context/useUXPContext';
import { useLogout } from '@core/services/useLogout';
import NotificationBlock from '@helper/NotificationBlock';
// Shown when the current user's permissions changed server-side. The backend expires
// the session after a grace period; this counts it down, lets the user log out early,
// and auto-logs-out when the countdown reaches zero.
export const PermissionChangedBanner = ({ expiresAt }) => {
    const context = useUXPContext();
    const logout = useLogout();
    const loggedOut = useRef(false);
    const [seconds, setSeconds] = useState(() => Math.max(0, expiresAt - Math.floor(Date.now() / 1000)));
    const expired = seconds <= 0;
    useEffect(() => {
        if (expired) {
            if (!loggedOut.current) {
                loggedOut.current = true;
                logout();
            }
            return;
        }
        const id = setTimeout(() => setSeconds(Math.max(0, expiresAt - Math.floor(Date.now() / 1000))), 1000);
        return () => clearTimeout(id);
    }, [seconds, expired, expiresAt, logout]);
    return (_jsx(NotificationBlock, { variant: "warning", mode: "compact", class: "uxpcore_notification--top-banner", message: expired
            ? context.$L('uxp-core.permission-changed.expired')
            : context.$L('uxp-core.permission-changed.message', { seconds }), action: !expired &&
            _jsx("button", { onClick: logout, children: context.$L('uxp-core.permission-changed.logout-now') }) }));
};
